import { render, staticRenderFns } from "./informacion_permisovacacion.vue?vue&type=template&id=76a9b5a7&scoped=true"
import script from "./informacion_permisovacacion.vue?vue&type=script&lang=js"
export * from "./informacion_permisovacacion.vue?vue&type=script&lang=js"
import style0 from "./informacion_permisovacacion.vue?vue&type=style&index=0&id=76a9b5a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a9b5a7",
  null
  
)

export default component.exports